<template>
  <div class="exposed-label">
    <!-- 
      1.1 当用户存在从业身份，则只展示1个优先级最高的从业身份；
      1.2 当用户不存在从业身份，则展示【成长体系等级】+ 1个优先级最高的用户自定义标签。 
    -->
    <div
      class="occupation"
      v-if="identityTag"
      :key="keyNum"
      @click="onIdentityTagClick"
    >
      <i
        v-if="isQingting"
        class="icon-occ is-qing-ting"
        :style="{
          background: `url(${identityTag.icon}) no-repeat top/100% 100%`
        }"
      ></i>
      <span v-else class="zx-tag">{{ identityTag.name }}</span>
    </div>
    <div class="identity-list" v-else :key="keyNum + 1">
      <!-- 浪花等级 -->
      <div class="identity-item level" v-if="parsedLevel">
        <p class="identity-item-text level-text">
          <img v-if="parsedLevel.icon" :src="parsedLevel.icon" alt="" />
          <span
            v-if="parsedLevel.levelVal"
            class="identity-item-text level-text"
          >
            {{ parsedLevel.levelVal }}&nbsp;
          </span>
          <span>{{ parsedLevel.levelName }}</span>
        </p>
      </div>
      <!-- 用户自定义标签 -->
      <div class="user-type" v-if="normalTag" @click="onNormalTagClick">
        <span class="type">{{ normalTag.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { isObject } from 'utils/tool.js'

export default {
  props: {
    // 不同的listType，代表入参不一样：
    // 类型2： 传入workList和tagList，还有userLevel
    // 类型1： 传入userIdentifyVoList，还有userLevel
    listType: {
      type: Number,
      required: true,
      validator(val) {
        return [1, 2].includes(val)
      }
    },
    // 身份标签列表
    workList: {
      type: Array,
      default: () => []
    },
    // 用户自定义标签列表
    tagList: {
      type: Array,
      default: () => []
    },
    userIdentifyVoList: {
      type: Array,
      default: () => []
    },
    // 浪花等级
    userLevel: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      keyNum: 100
    }
  },
  computed: {
    // 是否倾听师标签。倾听师的icon很长，icon里边已经包含了文字，所以倾听师标签只展示icon就可以了。
    isQingting() {
      return (
        this.identityTag &&
        (this.identityTag.isQingTing == 1 || this.identityTag.isQingtTing == 1)
      )
    },
    // 是否存在身份标签
    identityTag() {
      if (this.listType === 1 && Array.isArray(this.userIdentifyVoList)) {
        const { identityTag } = this.parseUserIdentifyVoList()
        return identityTag
      }
      return this.parseTag(this.workList)
    },
    // 是否存在用户自定义标签
    normalTag() {
      if (this.listType === 1 && Array.isArray(this.userIdentifyVoList)) {
        const { normalTag } = this.parseUserIdentifyVoList()
        return normalTag
      }
      return this.parseTag(this.tagList)
    },
    // 对浪花等级进行解析，以防接口乱来！
    parsedLevel() {
      return isObject(this.userLevel) && this.userLevel.levelName
        ? {
            ...this.userLevel,
            icon: this.userLevel.icon || this.userLevel.coin || '' // 接口混乱，前端这边统一下字段！
          }
        : null
    }
  },
  methods: {
    onIdentityTagClick() {
      this.$emit('identityTagClick', this.identityTag)
    },
    onNormalTagClick() {
      this.$emit('normalTagClick', this.normalTag)
    },
    parseTag(tagList) {
      return Array.isArray(tagList) && tagList.length ? tagList[0] : null
    },
    parseUserIdentifyVoList() {
      // isWork=1就代表是身份标签，isWork!=1就代表是用户自定义标签
      const workList = this.userIdentifyVoList.filter(
        item => +item.isWork === 1
      )
      const tagList = this.userIdentifyVoList.filter(item => +item.isWork !== 1)

      // 统一字段
      workList.forEach(item => {
        item.name = item.identifyName
      })
      tagList.forEach(item => {
        item.name = item.identifyName
      })

      return {
        identityTag: workList.length ? workList[0] : null,
        normalTag: tagList.length ? tagList[0] : null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.exposed-label {
  margin-top: 20px;

  .occupation {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #6c798c;
    .icon-occ {
      width: 46px;
      height: 38px;
      margin-right: 10px;
      &.is-qing-ting {
        width: 160px;
      }
    }
    .zx-tag {
      flex-grow: 0;
      height: 36px;
      padding: 0 10px 0 7px;
      background: #fff1ee;
      border-radius: 20px;
      font-size: 20px;
      font-weight: 400;
      color: #ff745b;
      line-height: 36px;
    }
  }

  .identity-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .identity-item {
    height: 36px;
    padding: 0 10px;
    background: #fff1ee;
    border-radius: 20px;
    font-size: 20px;
    font-weight: 400;
    color: #ff745b;
    &.level {
      margin-right: 10px;
      background: #f0f2ff;
      display: flex;
      align-items: center;
      justify-content: center;
      .level-text {
        color: #6982fa;
        display: flex;
        align-items: center;
        img {
          width: 34px;
          height: 34px;
          object-fit: cover;
          margin-right: 4px;
        }
      }
    }
  }

  .user-type {
    display: flex;
    align-items: center;
    .type {
      height: 40px;
      padding: 0 20px;
      background: #fff1ee;
      border-radius: 20px;
      line-height: 40px;
      font-size: 20px;
      color: #ff745b;
    }
  }
}
</style>
